var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_227_5794)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.94727 3.63038H12.0525M10.9297 3.63038V11.49C10.9297 12.0514 10.3683 12.6128 9.80691 12.6128H4.19288C3.63148 12.6128 3.07007 12.0514 3.07007 11.49V3.63038M4.75428 3.63038V2.50757C4.75428 1.94617 5.31569 1.38477 5.87709 1.38477H8.1227C8.68411 1.38477 9.24551 1.94617 9.24551 2.50757V3.63038M5.87709 6.4374V9.80582M8.1227 6.4374V9.80582",
    stroke: "white",
    strokeWidth: 1.26316,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_227_5794"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.4737,
    height: 13.4737,
    fill: "white",
    transform: "translate(0.263184 0.262695)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash2);
export default __webpack_public_path__ + "static/media/Trash2.2361a7188baa722f96f82d1564b23840.svg";
export { ForwardRef as ReactComponent };